import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { Loader2, Lock, Mountain } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(form.email, form.password);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-brass px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-panel p-9 shadow-2xl">
        <span className="grid h-11 w-11 place-items-center bg-brass text-ink">
          <Mountain size={19} />
        </span>
        <h1 className="mt-6 font-display text-4xl text-bone">Espace propriétaire</h1>
        <p className="mt-2 text-sm text-muted-foreground">Gérez vos prix, vos réservations et la synchronisation Airbnb.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block text-sm">
            <span className="mb-2 block font-medium text-bone">Email</span>
            <input required type="email" className="field" data-testid="login-email" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </label>
          <label className="block text-sm">
            <span className="mb-2 block font-medium text-bone">Mot de passe</span>
            <input required type="password" className="field" data-testid="login-password" value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </label>
          {error && <p className="bg-destructive/10 p-3 text-sm text-destructive" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
            {loading ? <Loader2 size={16} className="animate-spin" /> : <Lock size={15} />} Se connecter
          </button>
        </form>
        <Link to="/" className="mt-6 block text-center text-xs text-muted-foreground hover:underline">Retour au site</Link>
      </div>
    </div>
  );
}
